import { useQuery } from '@tanstack/react-query'
import api from '../../api'

const useEksClusterVersions = () => {
	return useQuery({
		queryKey: ['eksClusterVersions'],
		queryFn: () => api.clusters.getEksClusterVersions(),
		retry: false,
		staleTime: 5 * 60 * 1000,
		select(data) {
			const versions = data?.body
			if (!Array.isArray(versions)) {
				return []
			}
			return versions.filter((version): version is string => typeof version === 'string' && version.trim() !== '')
		}
	})
}

export default useEksClusterVersions
